export const CREATE_TARGETED_LEARNING_TEST = `
  mutation CreateTargetedLearningTest($courseName: String!, $studentId: String!) {
    createTargetedLearningTest(courseName: $courseName, studentId: $studentId) {
        testUrl,
        status
    }
 }`;
